
import { Vue, Component, Watch } from 'vue-property-decorator';
import { isWeiXin } from '@/common/ts/common';
import { getBaseInfo } from './api';

@Component
export default class ViewHolder extends Vue {
  baseInfo: any = {};

  @Watch('$route', { immediate: true })
  onRouteChange() {
    // 设置分享文案
    const cover =
      'https://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg';
    // App分享
    this.$appShareInfo({
      title: '重庆市好记者讲好故事——“我的记者故事”',
      url: location.href,
      subtitle: `一起来为喜爱的记者点赞助力`,
      classId: -1,
      id: -1,
      image: cover,
      type: 3,
    });
    // 微信分享
    if (isWeiXin()) {
      this.$wxShareInfo({
        title: '重庆市好记者讲好故事——“我的记者故事”',
        subtitle: `一起来为喜爱的记者点赞助力`,
        image: cover,
      });
    }
  }

  async created() {
    const ret = await getBaseInfo();
    this.baseInfo = ret.data;
    // 添加pv统计
    if (this.baseInfo.activityId) {
      this.$addPv(this.baseInfo.activityId);
    }
  }
}
